<template>
  <div class="flex flex-col justify-center items-center space-y-6">
    <dashboard-number-box class="bg-primary">
      {{ totalCampaigns }}
    </dashboard-number-box>
    <div class="my-2">
      <p class="text-primary font-medium text-2xl font-montserrat">Total Closed Campaigns</p>
      <p class="h-20 mt-2">The number of campaigns you have completed</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalCampaigns: {
      type: Number,
      require: true,
      default: 0,
    },
  },
};
</script>

<style></style>
